import { render, staticRenderFns } from "./passwordManager.vue?vue&type=template&id=3af2c0a0"
import script from "./passwordManager.vue?vue&type=script&lang=js"
export * from "./passwordManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports